import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
// import Backend from "i18next-locize-backend"; // Waiting to move to locize
import EnglishJson from "./language/en.json";
import JapaneseJson from "./language/ja.json";
import ChineseJson from "./language/zh.json";

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  // .use(Backend) // Waiting to move to locize
  .init({
    debug: false,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: EnglishJson,
      },
      ja: {
        translation: JapaneseJson,
      },
      zh: {
        translation: ChineseJson,
      },
    },
    // backend: {
    //   projectId: "",
    //   apiKey: "",
    // },
  });

export default i18n;
